import { CommonFilterViewComponent } from '@ntap/common';
import { startWith, tap } from 'rxjs';

export class FilterContainerUtil {
  static separateOsnovnaNaprednaPretraga(
    filterComponent: CommonFilterViewComponent
  ) {
    filterComponent.allowMultipleOpenSubcategories = false;
    filterComponent.addSubscription(
      filterComponent.openFilterGroup
        .pipe(
          startWith({ index: -1 }),
          tap(() => {
            FilterContainerUtil.clearAndRefetchDefaultFilter(filterComponent);
          })
        )
        .subscribe()
    );
    filterComponent.addSubscription(
      filterComponent.closeFilterGroup
        .pipe(
          startWith({ index: -1 }),
          tap(() => {
            FilterContainerUtil.clearAndRefetchDefaultFilter(filterComponent);
          })
        )
        .subscribe()
    );
  }

  private static clearAndRefetchDefaultFilter(
    filterComponent: CommonFilterViewComponent
  ): void {
    filterComponent['dynamicFormService'].clearFormValues();
    filterComponent.clearFilter();
  }
}
